import React, { useState, useEffect } from "react";
import {
  Link,
  useNavigate,
  useLocation
} from "react-router-dom";

import { useCart } from "../context/CartContext";

const Header = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const { cart } = useCart();

  const [mobile, setMobile] = useState(
    window.innerWidth <= 768
  );

  const [menuOpen, setMenuOpen] = useState(false);

  const token = localStorage.getItem("token");

  const user = JSON.parse(
    localStorage.getItem("user")
  );

  // =========================
  // RESPONSIVE
  // =========================

  useEffect(() => {

    const handleResize = () => {

      setMobile(
        window.innerWidth <= 768
      );

      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );

  }, []);

  // =========================
  // LOGOUT
  // =========================

  const logout = () => {

    localStorage.removeItem("token");

    localStorage.removeItem("user");

    navigate("/");
  };

  // =========================
  // ACTIVE LINK
  // =========================

  const activeLink = (path) => ({
    ...styles.link,

    background:
      location.pathname === path
        ? "#fff3e6"
        : "transparent",

    color:
      location.pathname === path
        ? "#ff5722"
        : "#333"
  });

  return (

    <header style={styles.header}>

      {/* ========================= */}
      {/* LOGO */}
      {/* ========================= */}

      <Link
        to="/"
        style={styles.logo}
      >
        🔮 Tuli Astro & Gems
      </Link>

      {/* ========================= */}
      {/* MOBILE MENU */}
      {/* ========================= */}

      {mobile && (

        <button
          style={styles.menuBtn}
          onClick={() =>
            setMenuOpen(!menuOpen)
          }
        >
          {menuOpen ? "✕" : "☰"}
        </button>

      )}

      {/* ========================= */}
      {/* NAVIGATION */}
      {/* ========================= */}

      {(!mobile || menuOpen) && (

        <nav
          style={{
            ...styles.nav,

            ...(mobile
              ? styles.mobileNav
              : {})
          }}
        >

          <Link
            to="/"
            style={activeLink("/")}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            Home
          </Link>

          <Link
            to="/products"
            style={activeLink("/products")}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            Products
          </Link>

          <Link
            to="/cart"
            style={activeLink("/cart")}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            🛒 Cart ({cart.length})
          </Link>

          {/* ========================= */}
          {/* LOGGED IN */}
          {/* ========================= */}

          {token ? (

            <>

              <Link
                to="/my-orders"
                style={activeLink("/my-orders")}
                onClick={() =>
                  setMenuOpen(false)
                }
              >
                My Orders
              </Link>

              {user?.role === "admin" && (

                <Link
                  to="/admin"
                  style={styles.adminBtn}
                  onClick={() =>
                    setMenuOpen(false)
                  }
                >
                  Admin
                </Link>

              )}

              <button
                style={styles.logoutBtn}
                onClick={logout}
              >
                Logout
              </button>

            </>

          ) : (

            <Link
              to="/login"
              style={styles.loginBtn}
              onClick={() =>
                setMenuOpen(false)
              }
            >
              Login
            </Link>

          )}

        </nav>

      )}

    </header>
  );
};

export default Header;

// =========================
// STYLES
// =========================

const styles = {

  header: {
    position: "sticky",
    top: 0,
    zIndex: 999,
    background: "#fff",
    borderBottom: "1px solid #eee",
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 20,
    boxShadow:
      "0 2px 12px rgba(0,0,0,0.05)"
  },

  logo: {
    textDecoration: "none",
    fontSize: 28,
    fontWeight: "bold",
    color: "#ff5722"
  },

  nav: {
    display: "flex",
    alignItems: "center",
    gap: 12
  },

  mobileNav: {
    position: "absolute",
    top: 75,
    left: 0,
    width: "100%",
    background: "#fff",
    flexDirection: "column",
    alignItems: "stretch",
    padding: 20,
    boxSizing: "border-box",
    borderBottom: "1px solid #eee"
  },

  link: {
    textDecoration: "none",
    color: "#333",
    padding: "10px 14px",
    borderRadius: 8,
    fontWeight: "bold",
    transition: "0.2s"
  },

  loginBtn: {
    textDecoration: "none",
    background: "#007bff",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: 8,
    fontWeight: "bold"
  },

  adminBtn: {
    textDecoration: "none",
    background: "#6f42c1",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: 8,
    fontWeight: "bold"
  },

  logoutBtn: {
    border: "none",
    background: "#dc3545",
    color: "#fff",
    padding: "10px 16px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold"
  },

  menuBtn: {
    border: "none",
    background: "#ff9800",
    color: "#fff",
    width: 42,
    height: 42,
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 22,
    fontWeight: "bold"
  }
};